<cbc-container [isLoading]="isLoading" [showContainer]="!isLoading" title="Dashboard" description="Painel prestador">
</cbc-container>

@if(!isLoading) {
<div class="container" [class.is_mobile]="isMobile">

  <!-- Header com saudação -->
  <div class="card dashboard-header">
    <div class="header-content">
      <div class="header-text">
        @if(profileProviderPF && profileProviderPF.name) {
        <div class="title-primary">Olá, {{ profileProviderPF.name }}!</div>
        } <div class="title-primary-description">Bem-vindo de volta ao seu painel</div>
      </div>
      @if(profileProviderPF && profileProviderPF.certifiedHubMedical) {
      <div class="certification-badge">
        <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado Hub Medical" width="48px" />
        <span>Certificado</span>
      </div>
      }
    </div>
  </div>

  <!-- Cards de estatísticas rápidas -->
  <div class="stats-grid">
    @if(profileProviderPF && hasFeatureAccess(profileProviderPF.cpf, Feature.SHARE_DOCUMENTS)) {
    <div class="stat-card card">
      <div class="stat-icon">
        <img src="assets/icons/icon_share_DUO.svg" alt="Certificado Hub Medical" width="48px" />
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ documentSharing.length || 0 }}</div>
        <div class="stat-label">Documentos Compartilhados</div>
      </div>
    </div>
    }

    @if(profileProviderPF && hasFeatureAccess(profileProviderPF.cpf, Feature.SERVICE_OFFERING)) {
    <div class="stat-card card">
      <div class="stat-icon">
        <img src="assets/icons/icon_publish_DUO.svg" alt="Certificado Hub Medical" width="48px" />
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ serviceOfferingProviderPF.length || 0 }}</div>
        <div class="stat-label">Ofertas Ativas</div>
      </div>
    </div>
    }

    @if(profileProviderPF && hasFeatureAccess(profileProviderPF.cpf, Feature.NEGOTIATION)) {
    <div class="stat-card card">
      <div class="stat-icon">
        <img src="assets/icons/icon_negoc_DUO.svg" alt="Certificado Hub Medical" width="48px" />
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ negotiations?.length || 0 }}</div>
        <div class="stat-label">Negociações</div>
      </div>
    </div>
    }
  </div>

  <!-- Menu Grid de Acesso Rápido -->
  <div class="title-section">Acesso Rápido</div>
  <div class="menu-grid">
    @if(profileProviderPF && canAccess(profileProviderPF.cpf)) {
    <a routerLink="/my-account/profiles/profileProviderPFForm" class="menu-item">
      <div class="menu-icon text-primary">
        <img src="assets/icons/icon_perfil.svg" alt="Certificado Hub Medical" width="48px" />
      </div>
      <span class="menu-label">Meu Perfil</span>
    </a>
    }

    @if(profileProviderPF && hasFeatureAccess(profileProviderPF.cpf, Feature.SHARE_DOCUMENTS)) {
    <a routerLink="shareDocuments" class="menu-item">
      <div class="menu-icon text-success">
        <img src="assets/icons/icon_shareDoc.svg" alt="Certificado Hub Medical" width="48px" />
      </div>
      <span class="menu-label">Compartilhamentos</span>
    </a>
    }

    @if(profileProviderPF && hasFeatureAccess(profileProviderPF.cpf, Feature.SERVICE_OFFERING)) {
    <a routerLink="serviceOffering" class="menu-item">
      <div class="menu-icon text-warning">
        <img src="assets/icons/icon_ofertas.svg" alt="Certificado Hub Medical" width="48px" />
      </div>
      <span class="menu-label">Ofertas</span>
    </a>
    }

    @if(profileProviderPF && hasFeatureAccess(profileProviderPF.cpf, Feature.NEGOTIATION)) {
    <a [routerLink]="['/providerPF', profileProviderPF.id, 'negotiationPainel', encriptCpfcnpj(profileProviderPF.cpf!)]"
      class="menu-item">
      <div class="menu-icon text-info">
        <img src="assets/icons/icon_negoc.svg" alt="Certificado Hub Medical" width="48px" />
      </div>
      <span class="menu-label">Negociações</span>
    </a>
    }
  </div>

  <!-- Seção de Informações do Perfil
  @if(profileProviderPF && canAccess(profileProviderPF.cpf)) {
  <div class="title-section">
    Informações do Perfil
    <button mat-icon-button routerLink="/my-account/profiles/profileProviderPFForm">
      <mat-icon>edit</mat-icon>
    </button>
  </div>
  <div class="profile-info">
    <p><strong>Nome:</strong> {{ profileProviderPF.name }}</p>
    <p><strong>Email:</strong> {{ profileProviderPF.email }}</p>
    <p><strong>CNS:</strong> {{ profileProviderPF.cnesCode || 'Não informado' }}</p>
    <p><strong>Telefone:</strong> {{ profileProviderPF.phoneNumber || 'Não informado' }}</p>
  </div>
  } -->

  <!-- Seção de Documentos Compartilhados -->
  @if(profileProviderPF && hasFeatureAccess(profileProviderPF.cpf, Feature.SHARE_DOCUMENTS)) {
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Documentos Compartilhados</h3>
      <button mat-stroked-button routerLink="shareDocuments" class="btn btn-outline">
        <mat-icon>arrow_forward</mat-icon>
        Ver Todos
      </button>
    </div>
    <div class="card-body">
      @if(documentSharing && documentSharing.length > 0) {

      @for (document of documentSharing.slice(0, 3); track $index) {
      <div class="file-card">
        <div class="file-icon">
          <img src="assets/icons/icon_folders_DUO.svg" alt="Certificado Hub Medical" width="48px" />

        </div>
        <div class="file-info">
          <ng-container *ngIf="getCompanyDto(document.grantedCompanyCnpj!) as companyDto">
            <h4 class="file-title">{{ companyDto.companyName }}</h4>
            <p class="file-name">
              @if(companyDto.certifiedHubMedical) {
              <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado" width="16px" />
              }
              Empresa certificada
            </p>
            <div class="file-meta">
              <p class="file-date">
                {{ document.active ? 'Ativo desde' : 'Inativo desde' }}
                {{ (document.active ? document.grantedDate : document.revokedDate) | date: 'dd/MM/yyyy' }}
              </p>
              <span class="file-status badge" [ngClass]="document.active ? 'badge-success' : 'badge-error'">
                {{ document.active ? 'Ativo' : 'Inativo' }}
              </span>
            </div>
          </ng-container>
        </div>
      </div>
      }

      } @else {
      <div class="empty-state">
        <mat-icon>folder_off</mat-icon>
        <p>Você ainda não tem documentos compartilhados</p>
      </div>
      }
    </div>
  </div>
  }
<br>
  <!-- Seção de Ofertas -->
  @if(profileProviderPF && hasFeatureAccess(profileProviderPF.cpf, Feature.SERVICE_OFFERING)) {
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Ofertas de Serviços</h3>
      <button mat-stroked-button routerLink="serviceOffering" class="btn btn-outline">
        <mat-icon>arrow_forward</mat-icon>
        Ver Todas
      </button>
    </div>
    <div class="card-body">
      @if(serviceOfferingProviderPF && serviceOfferingProviderPF.length > 0) {
      <div class="offers-list">
        @for (offer of serviceOfferingProviderPF.slice(0, 3); track $index) {
        <div class="offer-item">
          <div class="offer-icon">
            <img src="assets/icons/icon_publish_DUO.svg" alt="Certificado Hub Medical" width="48px" />
          </div>
          <div class="offer-content">
            <div class="offer-header">
              <strong>{{ offer.professionName }}</strong>
              <span class="badge badge-primary">{{ offer.specialty }}</span>
            </div>
            <div class="offer-footer">
              @if(offer.publicationDate) {
              <span class="offer-date">
                <mat-icon>calendar_today</mat-icon>
                Publicado em {{ offer.publicationDate | date: 'dd/MM/yyyy' }}
              </span>
              } @else {
              <span class="badge badge-warning">Não Publicado</span>
              }
            </div>
          </div>
        </div>
        }
      </div>
      } @else {
      <div class="empty-state">
        <mat-icon>local_offer</mat-icon>
        <p>Nenhuma oferta de serviço cadastrada</p>
      </div>
      }
    </div>
  </div>
  }
<br>
  <!-- Seção de Negociações -->
  @if(profileProviderPF && hasFeatureAccess(profileProviderPF.cpf, Feature.NEGOTIATION)) {
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Negociações Recentes</h3>
      <button mat-stroked-button
        [routerLink]="['/providerPF', profileProviderPF.id, 'negotiationPainel', encriptCpfcnpj(profileProviderPF.cpf!)]"
        class="btn btn-outline">
        <mat-icon>arrow_forward</mat-icon>
        Ver Todas
      </button>
    </div>
    <div class="card-body">
      @if(negotiations && negotiations.length > 0) {
      <div class="negotiations-list">
        @for (negotiation of negotiations.slice(0, 3); track $index) {
        <div class="negotiation-item">
          <div class="negotiation-icon">
            <img src="assets/icons/icon_negoc_DUO.svg" alt="Certificado Hub Medical" width="48px" />
          </div>
          <div class="negotiation-content">
            <div class="negotiation-header">
              <strong>{{ getParticipantDtoName(negotiation) }}</strong>
              <span class="badge badge-primary">{{ negotiation.status | enumDescription }}</span>
            </div>
            <p class="negotiation-message">{{ negotiation.initialMessage }}</p>
            <div class="negotiation-footer">
              <mat-icon>schedule</mat-icon>
              {{ negotiation.startDate | date: 'dd/MM/yyyy HH:mm' }}
            </div>
          </div>
        </div>
        }
      </div>
      } @else {
      <div class="empty-state">
        <mat-icon>forum</mat-icon>
        <p>Você ainda não tem negociações</p>
      </div>
      }
    </div>
  </div>
  }

</div>
}
""